/* Copyright 2013 - 2022 Waiterio LLC */
import React from 'react'
import { withRouter /* , Redirect */ } from 'react-router-dom'
// import isLoggedInSession from '../session/isLoggedInSession'

const AuthenticatedPage = ({ children }) =>
  children // isLoggedInSession() ? children : <Redirect to="/login" />

export default withRouter(AuthenticatedPage)
